<template>
    <div class="sup-advance-course-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">进阶教程</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_devCource_click" />
            </div>
            <div class="grid-list-box">
                <div
                    class="grid-item-box"
                    v-for="(item, index) in advance_course_list"
                    :key="`item_${index}`"
                    @click="jump_devCource_item_click(item)">
                    <img class="grid-item-img" src="@/assets/imgs/devDoc/advance_course_bg.png" />
                    <div class="gird-item-title-box">
                        <!-- <img class="item-icon" :src="require(`@/assets/imgs/devDoc/${item.icon}.png`)" /> -->
                        <img class="item-icon" :src="downloadBaseUrl_computed(item.accessory)" />
                        <span class="item-title">{{ item.title }}</span>
                    </div>
                    <div class="item-hover-box">
                        <div class="item-hover-title-box">
                            <img class="item-hover-icon" :src="downloadBaseUrl_computed(item.accessory)" />
                            <!-- <img class="item-hover-icon" :src="require(`@/assets/imgs/devDoc/${item.icon}.png`)" /> -->
                            <span class="item-hover-title">{{ item.title }}</span>
                        </div>
                        <span class="item-hover-dis">{{ item.description }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    advance_course_list: {
        type: Array,
        default: () => [],
    },
});

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

// MARK Click  跳转开发指南
const jump_devCource_click = () => {
    router_store.navigateToCourse();
};

// MARK Click Item  跳转开发教程
const jump_devCource_item_click = (item) => {
    router_store.navigateToCourse({ shareType: 1, treeId: item.dcId });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-advance-course-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 47px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 60px;
        row-gap: 40px;

        .grid-item-box {
            position: relative;
            display: flex;
            height: 193px;
            align-items: center;
            border-radius: 10px;
            cursor: pointer;
            overflow: hidden;
            flex-direction: column;
            background-color: var(--color-main-light-bg-white);
            box-shadow: var(--color-main-card-shadow-big);

            .grid-item-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }

            .gird-item-title-box {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 53px;
                display: flex;
                align-items: center;
                padding: 0 14px;
                box-sizing: border-box;
                backdrop-filter: blur(10px);

                .item-icon {
                    position: relative;
                    width: 28px;
                    height: 28px;
                }

                .item-title {
                    position: relative;
                    margin-left: 17px;
                    height: 30px;
                    font-weight: 400;
                    font-size: 20px;
                    color: var(--color-main-text-dark-bg-primary);
                }
            }

            .item-hover-box {
                position: absolute;
                top: -100%;
                left: 0;
                width: 100%;
                height: 100%;
                padding: 26px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                backdrop-filter: var(--color-main-backdrop-filte);
                background: var(--color-main-dev-center-backdrop-filter-background);
                transition: var(--animation-top-style);

                .item-hover-title-box {
                    position: relative;
                    width: 100%;
                    height: 30px;
                    display: flex;
                    align-items: center;

                    .item-hover-icon {
                        position: relative;
                        width: 28px;
                        height: 28px;
                    }

                    .item-hover-title {
                        position: relative;
                        margin-left: 17px;
                        height: 30px;
                        font-weight: 400;
                        font-size: 20px;
                        color: var(--color-main-text-dark-bg-primary);
                    }
                }

                .item-hover-dis {
                    position: relative;
                    margin-top: 10px;
                    width: 100%;
                    flex: 1;
                    font-weight: 400;
                    font-size: 13px;
                    color: var(--color-main-text-dark-bg-secondary);
                }
            }

            &:hover .item-hover-box {
                top: 0;
            }
        }
    }
}
</style>
